<template>
  <div style="width: 100%">
    <ion-grid>
      <ion-row style="height: 100%;" justify-content-center>
        <ion-col align-self-center size-md="5" size-lg="5" size-xs="12">
          <div style="margin: 2em 0 1em; width: 100%;" text-center>
            <!-- <img src="http://placehold.it/300x200" /> -->
            <img src="img/lawyerly-invert.logo.png" style="width: 80%; margin: auto;" />
            <!-- <h4>Login Form</h4> -->
          </div>
          <div padding>
            <ion-item>
              <ion-input
                v-ion-model="name"
                type="text"
                placeholder="Complete Name"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-input
                v-ion-model="email"
                type="text"
                placeholder="Email"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-input
                v-ion-model="password"
                type="password"
                placeholder="Password"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-input
                v-ion-model="confirmPassword"
                type="password"
                placeholder="Confirm Password"
              ></ion-input>
            </ion-item>
            <span class="error-text">{{ authStatus }}</span>
          </div>
          <div padding class="center-content">
            <ion-button @click="register" expand="block">
              Submit
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>
<script>
import { firebase as $firebase } from "@/firebase";
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      toastTimeout: 2000,
      authStatus: ""
    };
  },

  computed: {},

  methods: {
    back() {
      this.$router.go(-1);
    },

    checkPassword() {
      if (this.password && this.password.length > 0) {
        if (this.password.length < 6) {
          return {
            type: "is-danger",
            type2: "",
            message: "Password is too short."
          };
        }
        if (this.password !== this.confirmPassword) {
          return {
            type: "is-danger",
            type2: "is-danger",
            message: "Passwords do not match."
          };
        }
      }
      return {
        type: "",
        type2: "",
        message: ""
      };
    },

    async register() {
      if (this.email.length < 4 || !this.validateEmail(this.email)) {
        this.$ionic.showToast("Please enter a valid email address", {
          duration: this.toastTimeout
        });
        return;
      }

      var passwordCheck = this.checkPassword();
      if (passwordCheck.type !== "") {
        // this.$root.$emit('toast', passwordCheck)
        this.authStatus = passwordCheck.message;
        return;
      }

      // this.$root.$emit('indicator', true)
      await this.$ionic.showLoading("Please wait...", "cresent");

      $firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(async (res) => {
          //
          // this.$root.$emit('toast', {
          //   type: 'is-success',
          //   message: 'Registration successful.'
          // })
          // console.log(res);
          await res.user.updateProfile({
            displayName: this.name
          });
          console.log("Registration successful.");
          this.$router.replace("/profile/login");
        })
        .catch(error => {
          // Handle Errors here.
          // const errorCode = error.code
          const errorMessage = error.message;
          // this.$root.$emit('toast', {
          //   severity: 3,
          //   message: errorMessage
          // })

          this.authStatus = errorMessage;
        })
        .finally(() => {
          this.$ionic.dismissLoading();
        });
    },

    validateEmail(email) {
      /* eslint-disable no-useless-escape */
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(String(email).toLowerCase());
    },

    async toast(message, options) {
      await this.$ionic.toast.componentOnReady();
      this.$ionic.toast
        .create({
          message: message,
          showCloseButton: options.showCloseButton,
          position: options.position,
          closeButtonText: options.closeButtonText,
          duration: options.duration
        })
        .then(a => {
          a.present();
        });
    },

    async showIndicator(message, options) {
      await this.$ionic.loading.componentOnReady();
      this.indicator = await this.$ionic.loading.create({
        message: message,
        spinner: options.spinner,
        duration: options.duration
      });

      this.indicator.present();
      return Promise.resolve();
    }
  },

  mounted() {}
};
</script>
<style scoped>
ion-grid {
    width:100%;
    height: 100%;
    --background: #dfdfdf;
}

.error-text {
  color: #f44336;
  text-align: center;
  margin: 20px 0 15px 0;
  width: 100%;
  display: block;
  font-weight: 600;
}
</style>
